export const PARTNER_INFO_LOADED = 'partnerMemberships/PARTNER_INFO_LOADED';
